import get from 'lodash/get';
import { connect } from 'react-redux';

import { removeActiveSidebar } from '../../actions';
import AppComponent from '../../components/App';

export const mapStateToProps = ({ activeSidebar, user, propertyListError }: any) => ({
  activeSidebar,
  logoutRequested: get(user, 'logout'),
  propertyListError,
});

export default connect(mapStateToProps, { removeActiveSidebar })(AppComponent);
